module.exports = __webpack_public_path__ + "static/media/HeidiSalaets.954e7fc0.MP4";